// import { StateReducers } from 'state/reducers/types/StateReducers'

import {
  // RecaptchaConnectedProps,
  RecaptchaMapStateReturnType,
} from './types'

export const RecaptchaMapState = (): // state: StateReducers,
// props: RecaptchaConnectedProps,
RecaptchaMapStateReturnType => {
  // const currentLocation = state.currentLocation || undefined
  // const isRoutes = currentLocation && currentLocation.isRoutes
  // return { isRoutes }

  return {}
}
